import apiFetch from '../apiFetch'

export default function (financingId = 0, token) {
  return apiFetch({ endPoint: `FinanceCompany/${financingId}/Recover`, method: 'PUT', body: null, token: token })
}
